/**
 * Settings → Profile（/app/creditpullsetting 默认页）。
 * 打开页面打 STATSIG.COMMON.VIEW，value=settings_profile；Management 同组件 value=mgmt_profile。
 *
 * 正在用：Your Profile 表单，点 Update Profile 落库；Update Password 改密码。
 * 已不算：改字段、Add your photo（随 Update Profile 一起保存）。
 * Management 非 Owner 侧边栏的 Profile 是同一组件，不跨到 MGMT。
 */
export enum SettingsProfileEvent {
    /**
     * 点 Update Profile 或 Update Password。
     * 属性 type=profile|password
     */
    UPDATE = 'PROFILE_UPDATE',
}
